var isIe = navigator.userAgent.indexOf("MSIE ") > 0 || navigator.userAgent.indexOf("Trident") > 0 || navigator.userAgent.indexOf("Edge") > 0;

if(isIe){
    var $window = $(window);
    var skanGym = skanGym || {};

    $(function () {
        $window.trigger('resize');
    });

    $window.resize(function(){
        skanGym.ieFixes.headerBackground();
    });

    skanGym.ieFixes = new function(){


        this.headerBackground = function() {
            var width = $window.width(),
                height = parseInt(width/2) > 400 ? 400 : parseInt(width/2),
                $header = $('#header-site');
            if(novicell.responsive.isMd() || novicell.responsive.isLg()){
                $header.css({
                    'background-position-x': 0,
                    'background-size': width + 'px ' + height + 'px'
                });
            }
        };

    };
}
